<template>
	<div id="page-user-edit">
		<bread-crumbs
			v-if="activeTab === 0"
			:title="$t('Indicators.Indicators')"
			:subTitle="$t('general.SubtitleIndicators')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		></bread-crumbs>
		<div v-if="activeTab === 0" class="tab-text">
			<indicator-list-view
				v-if="indicatorsReadPermission"
				@selectedActivityEmit="selectedActivityEmit"
				@valueCreateIndication="valueIndicationEmit"
			/>
			<not-permission v-else></not-permission>
		</div>
		<div v-else-if="activeTab === 1" class="tab-text">
			<indicator-create-tab-information
				v-if="indicatorData.id === 0 && indicatorsCreatePermission"
				:data="indicatorData"
				@changeActiveTabEmit="valueIndicationEmit"
			/>
			<indicator-create-tab-information
				v-else-if="indicatorData.id > 0 && indicatorsUpdatePermission"
				:data="indicatorData"
				@changeActiveTabEmit="valueIndicationEmit"
			/>
			<not-permission v-else></not-permission>
		</div>
	</div>
</template>

<script>
import IndicatorCreateTabInformation from "./IndicatorCreateTabInformation.vue";
import IndicatorListView from "./IndicatorListView.vue";
import Indicator from "@/models/Indicator.js";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	components: {
		IndicatorCreateTabInformation,
		IndicatorListView,
		NotPermission,
	},
	data() {
		return {
			indicatorData: new Indicator({}),
			user_not_found: false,
			activeTab: 0,
		};
	},
	computed: {
		nameTabOne() {
			return this.indicatorData.id > 0
				? this.$t("Indicators.UpdateIndicator")
				: this.$t("Indicators.CreateIndicator");
		},
		indicatorsReadPermission() {
			return this.$store.getters.checkPermission("INDICATORS_R");
		},
		indicatorsCreatePermission() {
			return this.$store.getters.checkPermission("INDICATORS_C");
		},
		indicatorsUpdatePermission() {
			return this.$store.getters.checkPermission("INDICATORS_U");
		},
	},
	watch: {
		activeTab(tabNum) {
			if (tabNum === 0) {
				this.indicatorData = new Indicator({});
			}
		},
	},
	methods: {
		selectedActivityEmit(activity) {
			this.indicatorData = activity;
			this.activeTab = 1;
		},
		valueIndicationEmit(val) {
			this.activeTab = val;
			if (this.activeTab === 0) {
				this.indicatorData = new Indicator({});
			}
		},
	},
};
</script>
